import React from 'react';
import { translate } from '@utils/i18n';
export default function RushCell({ tdProps, dataItem }) {
    return (React.createElement("td", Object.assign({}, tdProps),
        React.createElement("span", null, dataItem.rush ? translate('yes', { namespace: 'generic' }) : translate('no', { namespace: 'generic' }))));
}
